import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Fetches the dumpster folder for archive mailbox folder tree and
 * adds mapping to session store.
 */

export interface FETCH_DUMPSTER_FOLDERActionMessage {
    mailboxInfo: MailboxInfo;
}
export const fetchDumpsterFolder: (mailboxInfo: MailboxInfo) => FETCH_DUMPSTER_FOLDERActionMessage =
    action(
        'FETCH_DUMPSTER_FOLDER',
        (mailboxInfo: MailboxInfo): FETCH_DUMPSTER_FOLDERActionMessage => ({
            mailboxInfo,
        })
    );
